export const calculationStatusNames = {
    "1": "New",
    "10": "Waiting",
    "11": "DWaiting",
    "2": "Running",
    "0": "Done",
    "-1": "Failed",
    "5": "Terminated",
};

export const calculationStatusIcons = {
    "1": ["hourglass-start", "#cccccc"],
    "10": ["hourglass-start", "#cccccc"],
    "11": ["hourglass-start", "#cccccc"],
    "2": ["spinner", "#225378"],
    "0": ["check", "#388E61"],
    "-1": ["times", "#DE350B"],
    "5": ["times", "#333333"],
};

export const jobStatusNames = {
    "1": "New",
    "3": "In progress",
    "-1": "Failed",
    "5": "Done",
};

export const topScoringInhibitors = {
    max: 100,
    perPage: 25,
};

export const basePath = process.env.PUBLIC_URL ?? "";

// REACT_APP_PIWIK_SITE_ID is used in index.html
// noinspection JSUnusedGlobalSymbols
export const piwikSiteId = process.env.REACT_APP_PIWIK_SITE_ID;

export const exampleJob = {
    code: "CDK4",
    position: 22,
    targetAA: "A",
    jobId: process.env.REACT_APP_EXAMPLE_ID || 'cdk4_K22A',
    jobIdAlias: 'example',
};

export const workflowImgPath = "/images/onco_workflow.svg";
export const workflowImgWidth = 600;

export const toolName = "PredictONCO";
export const toolSlug = "predictonco";
export const toolTitle = "Automated analysis of cancer-associated mutations and treatment selection";
export const toolVersion = process.env.REACT_APP_VERSION?.match(/^\d+\.\d+/)?.[0] ?? "";
export const toolKeywords = "automation, bioinformatics, cancer, exome, oncology, prediction, treatment, inhibitors, mutations, tumour, personalised medicine";
export const toolDescription = `${toolName}: ${toolTitle}`;
export const toolEmail = "predictonco@sci.muni.cz";
export const toolPublication = {
    authors: 'Stourac, J., Borko, S., Khan, R.T., Pokorna, P., Dobias, A., Planas-Iglesias, J., Mazurenko, S., Pinto, G., Szotkowska, V., Sterba, J., Slaby, O., Damborsky, J., Bednar, D.',
    year: '2023',
    title: 'PredictONCO: a web tool supporting decision-making in precision oncology by extending the bioinformatics predictions with advanced computing and machine learning',
    journal: 'Briefings in Bioinformatics',
    pubmedLink: 'https://pubmed.ncbi.nlm.nih.gov/38066711/',
    doiLink: 'https://doi.org/10.1093/bib/bbad441',
}

export const extraJobs = Number(process.env.REACT_APP_EXTRA_JOBS || "0");
export const extraVisitors = Number(process.env.REACT_APP_EXTRA_VISITORS || "0");
